import { gql } from '@apollo/client'

export const CONFIRM_LIBRE_INDIRECT_SYNC = gql`
  mutation confirmLibreIndirectSync {
    confirmLibreIndirectSync {
      success
    }
  }
`
